import { render, staticRenderFns } from "./_RecognitionSignatureDialog.vue?vue&type=template&id=da6c0164&"
import script from "./_RecognitionSignatureDialog.vue?vue&type=script&lang=js&"
export * from "./_RecognitionSignatureDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports